import styled from '@emotion/styled'

import { breakpoints, spacing } from 'main/ui'

export const AddressContainer = styled.div`
  margin-top: ${spacing.majorScale(1)}px;
  text-align: center;
`

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  > * {
    flex-basis: 0;
    flex-grow: 1;
    min-width: 0;
  }

  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(2)}px;
  }

  @media (min-width: ${breakpoints.lg}px) {
    flex-direction: row;

    > :not(:last-child) {
      margin-bottom: 0;
      margin-right: ${spacing.majorScale(2)}px;
    }
  }
`

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const SchoolSummaryContainer = styled.div`
  margin-top: ${spacing.majorScale(3)}px;
`

export const TimelineContainer = styled.div`
  height: 100%;
  width: 90%;
  margin: ${spacing.majorScale(6)}px 0;
`
